import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import {
  Box,
  Typography,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack'; // <-- ADDED
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { toast } from 'react-toastify';
import { formatDateTime } from '../../utils/notificationUtils';

function AnnouncementListPage() {
  const navigate = useNavigate();
  const [announcements, setAnnouncements] = useState([]);

  const fetchAnnouncements = async () => {
    try {
      const response = await api.get('/announcements'); // GET /announcements
      setAnnouncements(response.data);
    } catch (error) {
      console.error(error);
      toast.error('Failed to fetch announcements.');
    }
  };

  useEffect(() => {
    fetchAnnouncements();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this announcement?')) return;
    try {
      await api.delete(`/admin/announcements/${id}`); // DELETE /announcements/:id
      toast.success('Announcement deleted successfully!');
      fetchAnnouncements(); // refresh list
    } catch (error) {
      console.error(error);
      toast.error('Failed to delete announcement.');
    }
  };

  const handleEdit = (id) => {
    navigate(`/admin/announcements/edit/${id}`);
  };

  return (
    <Box sx={{ maxWidth: 800, margin: 'auto', mt: 3 }}>
      {/* Top Bar with Title + Back Button */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          mb: 2
        }}
      >
        <Typography variant="h5" gutterBottom>
          Announcements
        </Typography>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(-1)}
        >
          Back
        </Button>
      </Box>

      <Button
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
        onClick={() => navigate('/admin/announcements/new')}
      >
        Create New Announcement
      </Button>

      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>Message</TableCell>
            <TableCell>Start</TableCell>
            <TableCell>End</TableCell>
            <TableCell>Active?</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {announcements.map((a) => (
            <TableRow key={a.id}>
              <TableCell>{a.title}</TableCell>
              <TableCell>{a.message}</TableCell>
              <TableCell>{formatDateTime(a.start_date) || '-'}</TableCell>
              <TableCell>{formatDateTime(a.end_date) || '-'}</TableCell>
              <TableCell>{a.is_active ? 'Yes' : 'No'}</TableCell>
              <TableCell>
                <IconButton color="primary" onClick={() => handleEdit(a.id)}>
                  <EditIcon />
                </IconButton>
                <IconButton color="error" onClick={() => handleDelete(a.id)}>
                  <DeleteIcon />
                </IconButton>
              </TableCell>
            </TableRow>
          ))}

          {announcements.length === 0 && (
            <TableRow>
              <TableCell colSpan={6} align="center">
                No announcements found.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </Box>
  );
}

export default AnnouncementListPage;
